import { Radio } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  return (
    <footer className="relative bg-[#050209] border-t border-white/[0.06] py-12">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div data-testid={LANDING.footerLogo} className="flex items-center gap-2">
          <span className="relative flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-[#a259ff] via-[#c060ff] to-[#22d3ee]">
            <Radio className="h-3.5 w-3.5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display text-sm font-bold text-white">
            Geo<span className="text-[#a259ff]">Beats</span>
          </span>
        </div>

        <p className="text-xs text-[#7c6a9e] text-center">
          &copy; 2026 GeoBeats. Music, mapped in real time.
        </p>

        <div className="flex items-center gap-6 text-xs text-[#b9a9e6]">
          <a
            data-testid={LANDING.footerPrivacyLink}
            href={`${BACKEND_URL}/api/privacy`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#22d3ee] transition-colors"
          >
            Privacy Policy
          </a>
          <a
            data-testid={LANDING.footerSupportLink}
            href={`${BACKEND_URL}/api/support`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#22d3ee] transition-colors"
          >
            Support
          </a>
        </div>
      </div>
    </footer>
  );
};
